export default {
  methods: {
    updateValue(newValue) {
      this.$emit('input', { ...this.value, ...newValue })
    }
  },
  computed: {
    localStyle: {
      get() {
        return this.currentStyle
      },
      set(val) {
        this.$emit('update:currentStyle', val)
      }
    }
  }
}
